export const OMNIBOX_INDEX_NAME = 'angel_web_omnibox'
